import * as types from './types';

const segmentTypesInitial = {
  segmentTypes: [],
  segmentTypesRequest: false,
  segmentTypesSuccess: false,
  segmentTypesFailure: false,
};

const segmentsInitial = {
  segments: [],
  segmentsRequest: false,
  segmentsSuccess: false,
  segmentsFailure: false,
};

const initialState = {
  ...segmentTypesInitial,
  ...segmentsInitial,
};

export const segmentTypesRequest = (state) => ({
  ...state,
  ...segmentTypesInitial,
  segmentTypesRequest: true,
});

export const segmentTypesSuccess = (state, payload) => ({
  ...state,
  ...segmentTypesInitial,
  segmentTypesSuccess: true,
  segmentTypes: payload,
});

export const segmentTypesFailure = (state) => ({
  ...state,
  ...segmentTypesInitial,
  segmentTypesFailure: true,
});


export const segmentsRequest = (state) => ({
  ...state,
  ...segmentsInitial,
  segmentsRequest: true,
});

export const segmentsSuccess = (state, payload) => ({
  ...state,
  ...segmentsInitial,
  segmentsSuccess: true,
  segments: payload,
});

export const segmentsFailure = (state) => ({
  ...state,
  ...segmentsInitial,
  segmentsFailure: true,
});

export default(state = initialState, action) => {
  switch (action.type) {
    case types.SEGMENT_TYPES_REQUEST:
      return segmentTypesRequest(state);
    case types.SEGMENT_TYPES_SUCCESS:
      return segmentTypesSuccess(state, action.payload);
    case types.SEGMENT_TYPES_FAILURE:
      return segmentTypesFailure(state);

    case types.SEGMENTS_REQUEST:
      return segmentsRequest(state);
    case types.SEGMENTS_SUCCESS:
      return segmentsSuccess(state, action.payload);
    case types.SEGMENTS_FAILURE:
      return segmentsFailure(state);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/segments/index.js